import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';

import '../App.css';

import Header from './Header/Header';
import HeaderMenu from './Header/HeaderMenu';
import ThemeProvider from './Theme';
import Footer from './Footer';
import Home from './Home/Home';
import Mission from './Mission/Mission';
import MissionFiche from './Mission/MissionFiche';
import ScrollToTopOnMount from './ScrollToTopOnMount';
import Login from './Login';
import Logout from './Logout';
import Legal from './Legal/Legal';
import {
  login as initialeLogin,
  isStateKnown as authStateKnown,
  getCurrentUserRole,
  isLoggedIn,
} from '../ducks/authentication';

const styles = {
  drawerPaper: {
    top: 40,
    zIndex: 998,
    borderRadius: '0 0 5px 5px',
    padding: '5px 3px'
  },
  drawerModal: {
    zIndex: 997,
  }
};
class NoMatch extends Component {
  render() {
    return <div id="Error404">
      <div className="wrapper">
        <div className="content">
          <h1>Erreur 404</h1>
          <p>Page introuvable... :(</p>
        </div>
      </div>
    </div>
  }
}


class App extends Component {
  constructor(props) {
    super(props);
    this.state = {panelOpened: false};
    this._panelToggle = this._panelToggle.bind(this);
    console.log("Lobster v 1.1");
  }
  componentDidMount() {
    this.props.onMount();
  }
  _panelToggle() {
    this.setState({panelOpened: !this.state.panelOpened});
  }
  render() {

    const { loggedIn, authStateKnown, classes, userRole, width } = this.props;

    const barOffset = ['xs'].indexOf(width) >= 0 ? 120 : 220;

    const horizontalOffset = ['xs'].indexOf(width) >= 0 ? 50 : 58

    const sectionProps = {barOffset, horizontalOffset};

    return (
      <Router>
        <div className="App">
          <ThemeProvider>
            <ScrollToTopOnMount/>
            <Header width={this.props.width} onPanelToggle={this._panelToggle}/>
            <Drawer anchor="top" open={this.state.panelOpened} onClose={this._panelToggle} classes={{
                paperAnchorTop: classes.drawerPaper,
                modal: classes.drawerModal
              }}>
              <div className="Panel">
                <HeaderMenu menuSize={28} mode={'vertical'} onClick={this._panelToggle}/>
              </div>
            </Drawer>
            <Choose>
              <When condition={!loggedIn}>
                <Switch>
                  <Route exact path={'/'} component={Home}/>
                  <Route exact path={'/login'} component={Login}/>
                  <Route exact path={'/logout'} component={Logout}/>
                  <Route path={'/confidentialite'} component={Legal}/>
                  <Route path={'/360'} component={({match}) => (<MissionFiche sectionProps={sectionProps} missionId={'preview'} ficheId={'example'} width={width}/>)}/>
                  <Route path={'/fiche/anon/:ficheId'} component={({match}) => (<MissionFiche sectionProps={sectionProps} missionId={'anon'} ficheId={match.params.ficheId} width={width}/>)}/>
                  <Route component={NoMatch} />
                </Switch>
              </When>
              <When condition={authStateKnown !== undefined && loggedIn && (userRole === 'entreprise' || userRole === 'admin')}>
                <Switch>
                  <Route exact path={'/'} component={Home}/>
                  <Route exact path={'/login'} component={Login}/>
                  <Route exact path={'/logout'} component={Logout}/>
                  <Route path={'/confidentialite'} component={Legal}/>
                  <Route exact path={'/mission/:missionId?'} component={({match}) => (<Mission sectionProps={sectionProps} missionId={match.params.missionId}/>)}/>
                  <Route exact  path={'/mission/:missionId/fiche/:ficheId'} component={({match}) => (<MissionFiche sectionProps={sectionProps} missionId={match.params.missionId} ficheId={match.params.ficheId} width={width}/>)}/>
                  <Route exact  path={'/preview/a/fiche/:ficheId'} component={({match}) => (<MissionFiche sectionProps={sectionProps} missionId={'preview'} ficheId={match.params.ficheId} width={width}/>)}/>
                  <Route path={'/360'} component={({match}) => (<MissionFiche sectionProps={sectionProps} missionId={'preview'} ficheId={'example'} width={width}/>)}/>
                  <Route path={'/fiche/anon/:ficheId'} component={({match}) => (<MissionFiche sectionProps={sectionProps} missionId={'anon'} ficheId={match.params.ficheId} width={width}/>)}/>
                  <Route component={NoMatch} />
                </Switch>
              </When>
              <When condition={authStateKnown !== undefined && loggedIn && userRole === 'candidat'}>
                <Switch>
                  <Route exact path={'/'} component={Home}/>
                  <Route exact path={'/login'} component={Login}/>
                  <Route exact path={'/logout'} component={Logout}/>
                  <Route path={'/confidentialite'} component={Legal}/>
                  <Route path={'/360'} component={({match}) => (<MissionFiche sectionProps={sectionProps} missionId={'preview'} ficheId={'example'} width={width}/>)}/>
                  <Route path={'/profil'} component={({match}) => (<MissionFiche sectionProps={sectionProps} profile={true} width={width}/>)}/>
                  <Route path={'/fiche/anon/:ficheId'} component={({match}) => (<MissionFiche sectionProps={sectionProps} missionId={'anon'} ficheId={match.params.ficheId} width={width}/>)}/>
                  <Route component={NoMatch} />
                </Switch>
              </When>
            </Choose>
            <Footer width={width} style={{zIndex: 189, marginTop: -10}}/>
          </ThemeProvider>
        </div>
      </Router>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    authStateKnown: authStateKnown(state),
    loggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => dispatch(initialeLogin()),
  };
}

export default withWidth()(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(App)));



// WEBPACK FOOTER //
// ./src/components/App.js